export const PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT = {
    AREA_PREFIX: "o powierzchni",
    ROOMS_ADJECTIVE_FEMININE_FORMS: ["pokojowa", "pokojowa", "pokojowej"],
    ROOMS_ADJECTIVE_MASCULINE_FORMS: ["pokojowy", "pokojowy", "pokojowy"],
    ROOMS_ADJECTIVE_NEUTER_FORMS: ["pokojowe", "pokojowe", "pokojowe"],
    UNKNOWN_OFFER_TYPE: "nieruchomość"
} as const;
export const PROPERTY_CARD_DETAIL_OVERVIEW_CONTENT = {
    AREA_PREFIX: "o powierzchni",
    ROOMS_ADJECTIVE_FEMININE_FORMS: ["pokojowa", "pokojowa", "pokojowej"],
    ROOMS_ADJECTIVE_MASCULINE_FORMS: ["pokojowy", "pokojowy", "pokojowy"],
    ROOMS_ADJECTIVE_NEUTER_FORMS: ["pokojowe", "pokojowe", "pokojowe"],
    UNKNOWN_OFFER_TYPE: "nieruchomość"
} as const;
